"use client";
import AppButton from "../AppButton";
import "./style.css";

export type IAppTab = {
  id: number | string;
  label: string;
  icon?: string;
  iconWidth?: string;
  iconHeight?: string;
  onClick?: () => void;
  disabled?: boolean;
};

type IAppTabsProps = {
  tabs: IAppTab[];
  tabIndex?: number;
  setTabIndex?: (i: number) => void;
  onTabChange?: (index: number) => void;
  className?: string;
  activeStyle?: React.CSSProperties;
  inactiveStyle?: React.CSSProperties;
  activeClassName?: string;
  inactiveClassName?: string;
};

const AppTabs = ({
  tabs,
  tabIndex,
  setTabIndex,
  onTabChange,
  className,
  activeStyle,
  inactiveStyle,
  activeClassName,
  inactiveClassName,
}: IAppTabsProps) => {
  return (
    <div className="app-tabs">
      {tabs.map((tab, index) => (
        <AppButton
          key={tab.id || index}
          label={tab.label}
          icon={tab.icon}
          iconWidth={tab.iconWidth}
          disabled={tab.disabled}
          style={{ borderRadius: "0px", ...(tabIndex === index ? activeStyle : inactiveStyle) }}
          className={`app-tab ${tab.disabled ? "disabled" : ""} ${
            tabIndex === index ? `active ${activeClassName}` : `inactive ${inactiveClassName}`
          } ${className || ""}`}
          onClick={() => {
            if (tab.disabled) return;
            setTabIndex && setTabIndex(index);
            onTabChange && onTabChange(index);
            tab.onClick && tab.onClick();
          }}
        />
      ))}
    </div>
  );
};

export default AppTabs;
